<p style="width: 200px; height: 200px; background: red">
  {{pinId}}
</p>
